<template>
  <svg
    width="24"
    height="44"
    viewBox="0 0 24 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.292969 0L22.293 22L0.292969 44H1.70697L23.707 22L1.70697 0H0.292969Z"
      fill="#E5E7EB"
    />
  </svg>
</template>